/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

import { ApiRequestHandler, getApiKey } from "../ApiWeb";

let _rootDiv: HTMLDivElement | undefined = undefined;
let _currentSelectedFile: File | undefined = undefined;
let _uploadFileResponse: any = undefined;

export module UIFile {
    export function Bind(accessToken: string): void {
        _rootDiv = _InitializeUI(accessToken);
        document.body.appendChild(_rootDiv);
    }

    export function Unbind() {
        if (_rootDiv) {
            _rootDiv.remove();
        }
    }

    function _InitializeUI(accessToken: string): HTMLDivElement {
        let rootDiv = document.createElement("div");
        rootDiv.id = "ui-file-root-div";
        rootDiv.style.position = "absolute";
        rootDiv.style.top = "0";
        rootDiv.style.right = "300px";

        let titleELement = document.createElement("h2");
        titleELement.innerText = "Files";
        rootDiv.appendChild(titleELement);

        let inputElement: HTMLInputElement = document.createElement("input");
        inputElement.id = "ui-file-input";
        inputElement.setAttribute("type", "file");
        rootDiv.appendChild(inputElement);

        inputElement.addEventListener("change", async () => {
            let files: FileList | null = inputElement.files;
            if (files && files.length > 0) {
                const [file]: FileList = files;
                _currentSelectedFile = file;
                console.log("_currentSelectedFile", _currentSelectedFile);
            }
        });

        let brElement = document.createElement("br");
        rootDiv.appendChild(brElement);

        // upload button
        let uploadButton = document.createElement("button");
        uploadButton.id = "ui-file-upload-button";
        uploadButton.textContent = "Upload file";
        rootDiv.appendChild(uploadButton);

        // create click handler
        uploadButton.addEventListener("click", async () => {
            if (!_currentSelectedFile) {
                throw new Error("Invalid/Missing file to upload");
            }

            await _UploadFile(accessToken, _currentSelectedFile);
        });

        _uploadFileResponse = _CreateUIUploadResponse();
        rootDiv.appendChild(_uploadFileResponse);

        return rootDiv;
    }
    function _CreateUIUploadResponse(): HTMLDivElement {
        let oDiv: HTMLDivElement = document.createElement("div");
        oDiv.id = "ui-files-upload-response";
        oDiv.style.width = "150px";
        return oDiv;
    }
    function _RefreshUIUploadResponse(currentDiv: HTMLDivElement, sessionUri: string, fileId: string): void {
        // @ts-ignore
        currentDiv.innerHTML = DOMPurify.sanitize(`<br> session URI: ${sessionUri}, <br> file id: ${fileId}`);
    }

    async function _UploadFile(accessToken: string, file: File): Promise<void> {
        const contentType: string = "text/plain"; // Change this according to the file type
        const contentLength: number = file.size;
        const postResponse: any = await ApiRequestHandler.PostFilesUpload(getApiKey(), accessToken, file.name, contentType, contentLength);
        if (postResponse) {
            const fileId: string = postResponse.id;
            const sessionUri: string = postResponse.sessionUri;
            console.log(`Start of the upload session, id: ${fileId}, session uri: ${sessionUri}`);
            const buffer: ArrayBuffer = await _GetBufferFromFile(file);
            const putResponse: any = await ApiRequestHandler.PutFilesUpload(sessionUri, buffer, contentLength);
            if (putResponse.statusMessage) {
                console.log(`Upload session status: ${putResponse.statusCode} | ${putResponse.statusMessage}`);
            } else {
                console.log(`End of the upload session`, putResponse);

                _RefreshUIUploadResponse(_uploadFileResponse, sessionUri, fileId);
            }
        }
    }
    function _GetBufferFromFile(file: File): Promise<ArrayBuffer> {
        return new Promise((resolve: Function, reject: Function) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.result instanceof ArrayBuffer) {
                    resolve(reader.result);
                } else {
                    reject(new Error("Failed to read file as ArrayBuffer"));
                }
            };
            reader.onerror = () => {
                reject(reader.error);
            };
            reader.readAsArrayBuffer(file);
        });
    }
}
